import { breakpoints, Stack } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { screenReadersOnlyStyles } from '../../../../utils/styleUtils';
import FareRulesDrawerButton from '../common/FareRulesDrawerButton';
import TitledCard from '../../../../common/components/TitledCard';
import { useOrderDetails } from '../../containers/OrderDetailsContext';
import type { ScheduleChangeRefundOfferType } from './cancellation/models';
import MultiPnrRefundRequest from './MultiPnrRefundRequest';
import SinglePnrRefundRequest from './SinglePnrRefundRequest';

const contentStyles = css`
  @media (min-width: ${breakpoints._768}) {
    max-width: 568px;
  }
`;

interface RyanairRefundRequestProps {
  scheduleChangeRefundOffer: ScheduleChangeRefundOfferType | null;
}

const RyanairRefundRequest = ({ scheduleChangeRefundOffer }: RyanairRefundRequestProps) => {
  const { t } = useTranslation();
  const { flightInformation } = useOrderDetails();

  const hasManyPnrs = flightInformation.length > 1;

  return (
    <>
      <h1 className={screenReadersOnlyStyles}>{t('OrderDetails.Tab.ManageTrip.Description')}</h1>
      <Stack
        className={contentStyles}
        data-testid="ryanair-refund-request"
        spacing={{ [breakpoints._0]: 16, [breakpoints._970]: 24 }}
      >
        {scheduleChangeRefundOffer && !hasManyPnrs && (
          <SinglePnrRefundRequest scheduleChangeRefundOffer={scheduleChangeRefundOffer} />
        )}
        {hasManyPnrs && <MultiPnrRefundRequest />}
        <TitledCard headingAs="h2" title={t('ManageTrip.Cancel.AdditionalInformation.Title')}>
          <FareRulesDrawerButton
            snowplow={{
              category: 'Manage Trip',
              label: 'FARE_RULES',
              property: 'RYANAIR_REFUND_REQUEST',
            }}
          />
        </TitledCard>
      </Stack>
    </>
  );
};

export default RyanairRefundRequest;
